<template>
<v-container  text-xs-center>
  <h1>Go-France</h1>
  <h2>{{ name }}</h2>
Hello world

<qrcode-vue size=100 renderAs="svg" :value="value"></qrcode-vue>
<p style="bottom: 0;">Généré le {{ (new Date()).toLocaleDateString() }}</p>
</v-container>
</template>
<script>
//import firebase from '@firebase/app';
//import 'firebase/auth';
import QrcodeVue from 'qrcode.vue'

export default {
  props: ['value','name'],
  components:  {QrcodeVue},
  data: () => ({

  }),
  mounted() {
    //console.log(firebase.auth().currentUser);
  }
}
</script>
<style scoped>

</style>
